import { useQuery, type QueryFunctionContext } from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type {
  FailureFlagsAppsQueryOptions,
  FailureFlagsAppsQueryParams,
  FailureFlagsAppsQueryResult
} from 'queries/failure-flags/types'
import type { FailureFlagApplication } from 'types/api/failure-flags/failure-flags'

// QUery function responsible for the 'GET' method to fetch our applications list.
function fetchFailureFlagsApps({
  queryKey
}: QueryFunctionContext<ReturnType<typeof failureFlagsQueryKeys.getApps>>) {
  const endpointWithParams = getEndpointWithParams(...queryKey)
  return fetchQueryData<FailureFlagApplication[]>(endpointWithParams, {})
}

export function useGetFailureFlagsApps(
  queryParams: FailureFlagsAppsQueryParams | null,
  queryOptions?: FailureFlagsAppsQueryOptions
): FailureFlagsAppsQueryResult {
  const { currentTeamId: teamId } = useAuth()

  return useQuery({
    ...queryOptions,
    queryKey: failureFlagsQueryKeys.getApps({
      teamId,
      ...(queryParams ?? {})
    }),
    queryFn: fetchFailureFlagsApps
  })
}
